import { KeyRound, Loader2 } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Modal } from '@/components/ui/modal'
import { apiErrorMessage } from '@/i18n'
import { isApiError } from '@/lib/api/errors'
import { useUnlockVault } from './api'

/** Vault oturumu 15 dakika açık kalır; sunucu erişim sırrına dokunan işlemler bunu ister. */
export function VaultUnlockModal({ onUnlocked, onClose }: { onUnlocked: () => void; onClose: () => void }) {
  const { t } = useTranslation()
  const unlock = useUnlockVault()
  const [pin, setPin] = useState('')
  const [error, setError] = useState('')

  const submit = async () => {
    setError('')
    try {
      await unlock.mutateAsync(pin)
      onUnlocked()
    } catch (e) {
      setError(isApiError(e) && e.code === 'FORBIDDEN' ? t('updates.vault.wrongPin') : apiErrorMessage(e))
    }
  }

  return (
    <Modal
      open
      onOpenChange={(v) => !v && onClose()}
      size="sm"
      icon={<KeyRound />}
      title={t('updates.vault.title')}
      description={t('updates.vault.hint')}
      onSubmit={(e) => {
        e.preventDefault()
        void submit()
      }}
      footer={
        <>
          <Button type="button" variant="cancel" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button type="submit" disabled={pin.length < 4 || unlock.isPending}>
            {unlock.isPending ? <Loader2 className="animate-spin" /> : null}
            {t('updates.vault.unlock')}
          </Button>
        </>
      }
    >
      <div className="space-y-2">
        <Label htmlFor="vault-pin">{t('updates.vault.pin')}</Label>
        <Input
          id="vault-pin"
          type="password"
          inputMode="numeric"
          autoComplete="off"
          autoFocus
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          aria-invalid={!!error}
        />
        {error ? <p className="text-destructive text-xs">{error}</p> : null}
      </div>
    </Modal>
  )
}
